import { AccountStatusEnum } from './account-status.enum';

export default class AccountStatus {
  constructor(
    public status: AccountStatusEnum,
    public name: string,
    public nameEn?: string
  ) {}
}

// Получаем класс для выбранного статуса УЗ пользователя
export function getStatusClass(s: number | null): string {
  if (s == null) return '';
  if (
    s === AccountStatusEnum.RequestPasswordChange ||
    s === AccountStatusEnum.RequestDataChange ||
    s === AccountStatusEnum.EmailConfirmed ||
    s === AccountStatusEnum.PhoneConfirmed ||
    s === AccountStatusEnum.AwaitingEmailConfirmation ||
    s === AccountStatusEnum.AwaitingConfirmationController ||
    s === AccountStatusEnum.AwaitingPhoneConfirmation ||
    s === AccountStatusEnum.AccountRestored
  ) {
    return 'bg-warning';
  }
  if (s === AccountStatusEnum.Approved) {
    return 'bg-success';
  }
  if (
    s === AccountStatusEnum.ConfirmationCanceled ||
    s === AccountStatusEnum.AccountDeleted ||
    s === AccountStatusEnum.FinalConfirmationDenied ||
    s === AccountStatusEnum.MailNotConfirmed
  ) {
    return 'bg-error';
  }
  if (s === AccountStatusEnum.NotApproved) {
    return 'bg-info';
  }
  return '';
}

export function getStatusIcon(s: number): string {
  switch (s) {
    case AccountStatusEnum.NotApproved:
      return 'notApproved';
    case AccountStatusEnum.Approved:
      return 'approved';
    case AccountStatusEnum.RequestPasswordChange:
      return 'requestPasswordChange';
    case AccountStatusEnum.RequestDataChange:
      return 'requestDataChange';
    case AccountStatusEnum.ConfirmationCanceled:
      return 'confirmationCanceled';
    case AccountStatusEnum.AccountDeleted:
      return 'accountDeleted';
    case AccountStatusEnum.EmailConfirmed:
      return 'emailConfirmed';
    case AccountStatusEnum.AwaitingEmailConfirmation:
      return 'awaitingEmailConfirmation';
    case AccountStatusEnum.AwaitingConfirmationController:
      return 'awaitingConfirmationController';
    case AccountStatusEnum.AccountRestored:
      return 'accountRestored';
    case AccountStatusEnum.FinalConfirmationDenied:
      return 'finalConfirmationDenied';
    case AccountStatusEnum.MailNotConfirmed:
      return 'mailNotConfirmed';
    case AccountStatusEnum.PhoneConfirmed:
      return 'phoneСonfirmed';
    case AccountStatusEnum.AwaitingPhoneConfirmation:
      return 'sendPhone';
    default:
      return '';
  }
}